"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleName = exports.FragmentName = void 0;
var FragmentName;
(function (FragmentName) {
    FragmentName["accountSettings"] = "account-settings";
    FragmentName["authPage"] = "auth-page";
    FragmentName["billing"] = "billing";
    FragmentName["collaboration"] = "collaboration";
    FragmentName["configurationSettings"] = "configuration-settings";
    FragmentName["contentEditor"] = "content-editor";
    FragmentName["homePage"] = "home-page";
    FragmentName["learners"] = "learners";
    FragmentName["materialEditor"] = "material-editor";
    FragmentName["materialList"] = "material-list";
    FragmentName["materialResults"] = "material-results";
    FragmentName["mediaLibrary"] = "media-library";
    FragmentName["notification"] = "notification";
    FragmentName["organization"] = "organization";
    FragmentName["preview"] = "preview";
    FragmentName["publish"] = "publish";
    FragmentName["questionEditor"] = "question-editor";
    FragmentName["review"] = "review";
})(FragmentName || (exports.FragmentName = FragmentName = {}));
var ModuleName;
(function (ModuleName) {
    ModuleName["uiKit"] = "ui-kit";
    ModuleName["sharedModules"] = "shared-modules";
    ModuleName["froalaEditor"] = "froala-editor";
})(ModuleName || (exports.ModuleName = ModuleName = {}));
